import Box from '@mui/material/Box';
import { Input } from '../../../../../shared/components/Input';
import Divider from '@mui/material/Divider';
import { DatetimeBR } from '../../../../../shared/utils/helpers/date';
import { TabPanel } from '@mui/lab';


export const TabDados = ({values} : { values: any }) => {
  return (
    <TabPanel value='1'>
      <form autoComplete='off' onSubmit={() => console.log('oi')} name='customer-detail'>
        <Box className='grid grid-cols-8 gap-7 pt-4'>
          <Input
            disabled={true}
            label='Empresa'
            className='col-span-3'
            name='usu_nome'
            value={values?.nfeProc?.NFe?.infNFe?.dest?.xNome}
          />
          <Box className={'col-span-5'} />
          <Divider className={'col-span-8'} />
          <Input
            disabled={true}
            label='Nat. da Operação'
            className='col-span-4'
            name='natOp'
            value={values?.nfeProc?.NFe?.infNFe?.ide?.natOp}
          />
          <Box className={'col-span-4'} />
          <Input
            disabled={true}
            label='Data de Emissão'
            className='col-span-1'
            name='natOp'
            value={DatetimeBR.getFullFriendlyDate(values?.nfeProc?.NFe?.infNFe?.ide?.dhEmi ?? '', true)}
          />
          <Input
            disabled={true}
            label='N da NF-e'
            className='col-span-1'
            name='natOp'
            value={values?.nfeProc?.NFe?.infNFe?.ide?.nNF}
          />
          <Box className={'col-span-6'} />
          <Input
            disabled={true}
            label='Data Saída / Entrada'
            className='col-span-1'
            name='natOp'
            value={DatetimeBR.getFullFriendlyDate(values?.nfeProc?.NFe?.infNFe?.ide?.dhSaiEnt ?? '', true)}
          />
          <Input
            disabled={true}
            label='Tipo da Nota'
            className='col-span-1'
            name='natOp'
            value={values?.nfeProc?.NFe?.infNFe?.ide?.tpNF === 1 ? 'Saída' : values?.nfeProc?.NFe?.infNFe?.ide?.tpNF === 0 ? 'Entrada' : ''}
          />
          <Input
            disabled={true}
            label='Tipo da Nota'
            className='col-span-1'
            name='natOp'
            value={values?.nfeProc?.NFe?.infNFe?.ide?.serie}
          />
        </Box>
      </form>
    </TabPanel>
  )
}